import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const CloseSimple = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2739 22.2738L37.1231 37.123"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2739 37.123L37.1231 22.2738"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
export default CloseSimple;
